/* Vuex module - global */
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  pendingAsyncStoreActions: [],
  isInformationModalVisible: false,
  isCookieBarVisible: false,
};

const getters = {
  pendingAsyncStoreActions: (state) => ({
    includes(pendingActions = []) {
      const allPendingActions = pendingActions;
      return state.pendingAsyncStoreActions.some((a) => allPendingActions.includes(a));
    },
  }),
  isInformationModalVisible: (state) => state.isInformationModalVisible,
  isCookieBarVisible: (state) => state.isCookieBarVisible,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
export default {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};
